import React from 'react'
import { Link } from 'react-router-dom'
import constants from '../../constants'
import _ from 'lodash'

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as orderActions from '../../actions/order_actions';

class CustomSizeBox extends React.Component {
  constructor(props) {
    super(props);
    this.slug = constants.GROUP_TYPES.SIZE.CUSTOM_SIZE;
    this.group = 'size';
    this.updateTimeout = null;
    this.updateWidthTimeout = null;
  }

  handleClick = (e) => {
    this.props.onGroupSelected(this.group, this.slug);
    if (this.height && this.width) {
      this.tryToUpdateSizes();
    }
  };

  heightChanged(e) {
    if (!this.props.constructions_state.selected_type) { return false; }
    let
      val = e.target.value,
      _this = this,
      sizes = this.props.constructions_state.selected_type.custom_sizes,
      limits = this.props.constructions_state.selected_type.size_limits;

    clearTimeout(this.updateTimeout);

    this.updateTimeout = setTimeout(() => {
      if (val > limits.max_height) {
        val = limits.max_height;
        _this._heightInput.value = val;
      }
      // Set min value if value < min height (removed)
      // if (val < limits.min_height) {
      //   val = limits.min_height;
      //   _this._heightInput.value = val;
      // }

      _this.height = _.filter(sizes, (item) => {
        return item.min_value <= val && item.max_value >= val && item.size_type == 'высота'
      })[0];

      _this.height && (_this.height.value = val);
      _this.tryToUpdateSizes();
    }, 100);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.orderState[this.group].selected != this.slug) {
      this._heightInput.value = '';
      this._widthInput.value = '';
    }
  }

  componentDidMount() {
    let { groups: { size } } = this.props.order_state;
    this._heightInput.value = _.get(size, 'items[0].value');
    this._widthInput.value = _.get(size, 'items[1].value');
  }

  widthChanged(e) {
    if (!this.props.constructions_state.selected_type) { return false; }
    let
      val = e.target.value,
      _this = this,
      sizes = this.props.constructions_state.selected_type.custom_sizes,
      limits = this.props.constructions_state.selected_type.size_limits;

    clearTimeout(this.updateWidthTimeout);
    this.updateWidthTimeout = setTimeout(() => {
      if (val > limits.max_width) {
        val = limits.max_width;
        _this._widthInput.value = val;
      }

      // Set min value if value < min width (removed)
      // if (val < limits.min_width) {
      //   val = limits.min_width;
      //   _this._widthInput.value = val;
      // }

      _this.width = _.filter(sizes, (item) => {
        return item.min_value <= val && item.max_value >= val && item.size_type == 'ширина'
      })[0];
      _this.width && (_this.width.value = val);

      _this.tryToUpdateSizes();
    }, 100);
  }

  tryToUpdateSizes() {
    const { customSizeSelected } = this.props.order_actions;
    customSizeSelected([this.height, this.width], [this._heightInput.value * 1, this._widthInput.value * 1]);
  }

  render() {
    let limits = {};

    if (this.props.constructions_state.selected_type) {
      limits = this.props.constructions_state.selected_type.size_limits;
    }

    return (
      <div className={`wizard-block-form selectable-block ${this.props.orderState[this.group].selected == this.slug ? 'selected' : ''}`}
           onClick={this.handleClick}>
        <div className='selectable-block-indicator'></div>
        <div className='selectable-block-title'>Индивидуальный размер</div>
        <div className='form'>
          <div className='form-row inline- two-cols-'>
            <div className='form-item'>
              <div className='label'>
                Ширина, мм {`${limits.min_width} - ${limits.max_width}`}
              </div>
              <div className='field'>
                <input ref={ node => this._widthInput = node } type="number" onChange={ this.widthChanged.bind(this) }  max={limits.max_width} min={limits.min_width} maxLength="5"/>
              </div>
            </div>
            <div className='form-item'>
              <div className='label'>
                Высота, мм {`${limits.min_height} - ${limits.max_height}`}
              </div>
              <div className='field'>
                <input ref={ node => this._heightInput = node } type='number' onChange={ this.heightChanged.bind(this) } max={limits.max_height} min={limits.min_height} maxLength="5" />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    constructions_state: state.constructionsState,
    order_state: state.orderState,
  }
};

const mapDispatch = (dispatch) => {
  return {
    order_actions: bindActionCreators(orderActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatch, null, {pure: false})(CustomSizeBox);



// WEBPACK FOOTER //
// ./app/javascript/app/components/custom_size_box/index.jsx